// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__5c3a1","welcome":"Profile_welcome__CzlIC","serverResponseMessage":"Profile_serverResponseMessage__qbO27"};